module.exports = __webpack_public_path__ + "prompted.a846c8b2a7b93fed6f279c8744bd6d96.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/variables/prompted.png
// module id = 1277
// module chunks = 1